import { Reducer } from 'redux';

import { LOV_ACTIONS, ILOVActions } from './actions';
import { ILOV } from 'stubs/graphql/lov';

export interface ILOVStore {
  itemCategory: ILOV[];
  itemSubCategory: ILOV[];
  itemQuality: ILOV[];
  itemStyle: ILOV[];
  itemBrandCategory: ILOV[];
  itemSize: ILOV[];
  itemMaterial: ILOV[];
  membershipType: ILOV[];
  memberSource: ILOV[];
  deliveryType: ILOV[];
  deliveryTypeCollectStatus: ILOV[];
}

export const initialState: ILOVStore = {
  itemCategory: [],
  itemSubCategory: [],
  itemQuality: [],
  itemStyle: [],
  itemBrandCategory: [],
  itemSize: [],
  itemMaterial: [],
  membershipType: [],
  memberSource: [],
  deliveryType: [],
  deliveryTypeCollectStatus: [],
};

// --------------
// Reducer
// --------------

export const lovReducer: Reducer<ILOVStore, ILOVActions> = (
  state: ILOVStore = initialState,
  action: ILOVActions
) => {
  switch (action.type) {
    case LOV_ACTIONS.UPDATE_RETRIEVED_ITEM_LOV:
      return {
        ...state,
        itemCategory: action.itemCategory,
        itemSubCategory: action.itemSubCategory,
        itemQuality: action.itemQuality,
        itemStyle: action.itemStyle,
        itemBrandCategory: action.itemBrandCategory,
        itemSize: action.itemSize,
        itemMaterial: action.itemMaterial,
      };
    case LOV_ACTIONS.UPDATE_RETRIEVED_MEMBERSHIP_TYPE_LOV:
      return {
        ...state,
        membershipType: action.membershipType,
      };
    case LOV_ACTIONS.UPDATE_RETRIEVED_MEMBER_SOURCE_LOV:
      return {
        ...state,
        memberSource: action.memberSource,
      };
    case LOV_ACTIONS.UPDATE_RETRIEVED_DELIVERY_LOV:
      return {
        ...state,
        deliveryType: action.deliveryType,
        deliveryTypeCollectStatus: action.deliveryTypeCollectStatus,
      };
    default:
      return state;
  }
};
